var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "496F6E6A-4274-47EA-94AA-DDED79A27C0D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.X.10-Blueprints---Components---New-Component---SalesPerson",
    transform: "translate(-863.000000, -328.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(863.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,-5.95079541e-14 C12.418278,-5.95079541e-14 16,3.581722 16,8 C15.9951012,12.4162473 12.4162473,15.9951012 8,16 C3.581722,16 -3.67794684e-12,12.418278 -3.67794684e-12,8 C-3.67794684e-12,3.581722 3.581722,-5.95079541e-14 8,-5.95079541e-14 Z M8,11.5555556 C7.50908022,11.5555556 7.11111111,11.9535247 7.11111111,12.4444444 C7.11111111,12.9353642 7.50908022,13.3333333 8,13.3333333 C8.49091978,13.3333333 8.88888889,12.9353642 8.88888889,12.4444444 C8.88888889,11.9535247 8.49091978,11.5555556 8,11.5555556 Z M8,1.77777778 C7.50908022,1.77777778 7.11111111,2.17574689 7.11111111,2.66666667 L7.11111111,9.77777778 C7.11111111,10.2686976 7.50908022,10.6666667 8,10.6666667 C8.49091978,10.6666667 8.88888889,10.2686976 8.88888889,9.77777778 L8.88888889,2.66666667 C8.88888889,2.17574689 8.49091978,1.77777778 8,1.77777778 Z",
    id: "Combined-Shape-Copy-4"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infoWarning.2d6f8fa660ba82ddf6a35501f5972113.svg";